import Revista from "@/views/Revista.vue";

const revista = {
  path: "/revista",
  name: "revista",
  component: Revista,
};

export default revista;
